import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MM_LABEL } from "./mmConfig";

export default function MmBenchmarkDashboard() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">MM Portfolio Management</h1>
          <p className="text-muted-foreground text-sm">{MM_LABEL}</p>
        </div>
        <Button variant="outline" size="sm">
          <RefreshCw className="h-4 w-4 mr-1" /> Refresh
        </Button>
      </div>
    </div>
  );
}
